enum PaymentProcessorsEnum {
  InvalidId = -1,
  Stripe = 1,
  PayPal = 2,
  Paysera = 3,
  ShipzeeBalance = 4,
}

export default PaymentProcessorsEnum
